import React, { useEffect, useRef, useState } from "react";
import InsideHeader from "../../components/InsideHeader";
import { Form, Spin, Tree } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { 
  fetchReportTree,
} from "../../features/dropdown/dropdownSlice";
import GenerateModal from "./GenerateModal";
 

function MainReports() {
  const handleOk = () => {
    setExpandedKeys([]);
    setTreeData([
      { title: "Tree Node", key: "0", isLeaf: false, disableCheckbox: true },
    ]);
  };
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formRef = useRef(null); 

  const { user } = useSelector((state) => state.auth);
  const [prodd,setProdd] =  useState('')

  const [open, setopen] = useState(false);

 async function handleCancel() {
   await setopen(false); 
   await setCheckedKeys([])
  }

  const { loading, reportTree } = useSelector((state) => state.dropdown);
  const dispatch = useDispatch();

   const [treeData, setTreeData] = useState([
      { title: "PICKPAY-HRM", key: "system_7", isLeaf: false, disableCheckbox: true },
    ]); 
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

  const fetchChildren = async (key) => {
    try {
      const res = await dispatch(
        fetchReportTree({ 
          node: key,
        })
      );
      if (res?.payload) {
        const checkedKeysFromResponse = res?.payload
          .filter((item) => item?.checked)
          .map((item) => item?.id);

        setCheckedKeys(checkedKeysFromResponse);

        return res?.payload?.map((item) => ({
          title: item?.text,
          key: item?.id,
          isLeaf: item?.cls === "file",
          disableCheckbox: item?.cls === "folder",
          cls: item?.cls,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching children: ", error);
      return [];
    }
  };

  const onExpand = async (expandedKeys, { expanded, node }) => {
    if (expanded) {
      setExpandedKeys(expandedKeys);
      if (expandedKeys?.includes("applications") && expandedKeys?.includes("0")) {
        setExpandedKeys((prevKeys) => {
          return ["applications", "0", node.key];
        });
      } else if (
        expandedKeys?.includes("reports") &&
        expandedKeys?.includes("0")
      ) {
        setExpandedKeys((prevKeys) => {
          return ["reports", "0", node.key];
        });
      }

      const children = await fetchChildren(node?.key);
      setTreeData((prevTreeData) =>
        updateTreeData(prevTreeData, node?.key, children)
      );
    } else {
      setExpandedKeys(expandedKeys);
    }
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node?.key === key) {
        return { ...node, children };
      }
      if (node?.children) {
        return {
          ...node,
          children: updateTreeData(node?.children, key, children),
        };
      }
      return node;
    });
  };

  const onCheck = async (checkedKeysValue, { checked, node }) => {
    if (node?.cls === "folder") { 
      return;
    }
    const singleCheckedKey = checked ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);  
    await setProdd(node);  
    await setopen(checked);   
  };

  const onSelect = async (selectedKeys, { selected, node }) => {
    if (node?.cls === "folder") { 
      return;
    }
    const singleCheckedKey = selected ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);
    await setProdd(node);
    await setopen(selected);
  };
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Reports"
        subtitle="Manage and generate reports"
        back={false}
      />

      <div className="bg-white mt-[1.25rem] rounded-[10px] min-h-[100vh] p-10">
        <Spin spinning={loading}>
          <Tree
            checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            checkedKeys={checkedKeys}
            onCheck={onCheck}
            onSelect={onSelect} 
            treeData={treeData} 
          />
        </Spin> 
      </div>

      <GenerateModal 
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
    </div>
  );
}

export default MainReports;
